module.exports = "/_next/static/images/address_footer-efca7ca81b08ea95ee9e16bbcce3de77.png";